import axios from 'axios';
import domReady from '../helpers/dom-ready';
import checkUser from '../helpers/check-user';

class WCSingleProduct {
  static init(...parameters) {
    return new WCSingleProduct(...parameters);
  }

  constructor() {
    this.productSingleWrapper = document.querySelector('.product-single-wrapper');
    this.selectedProductsWrapper = document.querySelector('.selected-products-wrapper');

    if (this.productSingleWrapper) {
      this.checkUser();
    }
  }

  checkUser() {
    const restUrl = document.querySelector('meta[name="rest-url"]').getAttribute('content');

    const productEl = this.productSingleWrapper.querySelector('.product');
    const id = productEl.id.replace('product-', '');

    const productPriceEl = productEl.querySelector('.product-price');
    const productAmountAndSinglePriceEl = productEl.querySelector('.product-single-price');
    const productAmountEl = productAmountAndSinglePriceEl.querySelector('.amount');
    const productSinglePriceEl = productAmountAndSinglePriceEl.querySelector('.price');
    const stockStatusEl = productEl.querySelector('.product-stock-status');
    const cartWrapperEl = productEl.querySelector('.cart-wrapper');
    const accountTextEl = productEl.querySelector('.account-text');
    const findShopButtonEl = productEl.querySelector('.find-shop');
    const productDeliveryTextEl = productEl.querySelector('.product-delivery-text');

    checkUser(
      () => {
        axios.get(`${restUrl}brix/v1/product/${id}`)
          .then((productResponse) => {
            if (productResponse.data) {
              const {
                formattedPrice, productAmount, formattedSinglePrice, stockQuantity,
              } = productResponse.data[id];

              productPriceEl.innerHTML = `${formattedPrice}${productPriceEl.innerHTML}`;
              productAmountEl.innerHTML = `${productAmount}${productAmountEl.innerHTML}`;
              productSinglePriceEl.innerHTML = `${formattedSinglePrice}${productSinglePriceEl.innerHTML}`;

              const { soonInStockMessage, inStockMessage } = stockStatusEl.dataset;
              stockStatusEl.innerHTML = stockQuantity < 1 ? soonInStockMessage : inStockMessage;
              if (stockQuantity > 0) { stockStatusEl.classList.add('-in-stock'); }

              productPriceEl.classList.remove('-hidden');
              productAmountAndSinglePriceEl.classList.remove('-hidden');
              stockStatusEl.classList.remove('-hidden');
              cartWrapperEl.classList.remove('-hidden');
              productDeliveryTextEl.classList.remove('-hidden');

              accountTextEl.classList.add('-hidden');
              findShopButtonEl.classList.add('-hidden');
            }
          })
          .catch((e) => {
            console.log(`Error: ${e}`);
          });

        if (this.selectedProductsWrapper) {
          const selectedProducts = this.selectedProductsWrapper.querySelectorAll('.selected-products-wrapper .products .product');
          const productIds = [...selectedProducts].map((product) => product.dataset.productId);

          axios.get(`${restUrl}brix/v1/product/${productIds.toString()}`)
            .then((productsResponse) => {
              if (productsResponse.data) {
                selectedProducts.forEach((product) => {
                  const { productId } = product.dataset;

                  const priceAmountWrapper = product.querySelector('.price-amount-wrapper');

                  const selectedProductPriceEl = priceAmountWrapper.querySelector('.product-price');
                  const selectedProductAmountEl = priceAmountWrapper.querySelector('.product-amount');
                  const { formattedPrice, productAmount } = productsResponse.data[productId];

                  selectedProductPriceEl.innerHTML = `${formattedPrice} ${selectedProductPriceEl.innerHTML}`;
                  selectedProductAmountEl.innerHTML = `${productAmount} ${selectedProductAmountEl.innerHTML}`;

                  priceAmountWrapper.classList.remove('-hidden');
                });
              }
            })
            .catch((e) => {
              console.log(`Error: ${e}`);
            });
        }
      },
      () => {
        accountTextEl.classList.remove('-hidden');
        findShopButtonEl.classList.remove('-hidden');
      },
    );
  }
}

domReady(() => {
  WCSingleProduct.init();
});
